import React from "react";
import "./YellowNewsUpdate.css";

const YellowNewsUpdate = () => {
  return (
    <div className="container">
      <div className="news-bar">
        <div className="yellow-box"></div>
        <div className="blue-bar"></div>
      </div>
      <div className="background">
        <div className="white-flair"></div>
      </div>
    </div>
  );
};

export default YellowNewsUpdate;
